import { SessionsGroup, UserSession, Examination } from "@/models";
import { useRepo, Model } from "pinia-orm";

export default class Session extends Model {
  static entity = "sessions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      status: this.string(""),
      isDisplayed: this.boolean(true),
      nbSession: this.number(null),
      isOpenSession: this.boolean(false),

      // Foreign keys
      userSessionsList: this.hasMany(UserSession, "sessionUuid"),
      examinationUuid: this.string(""),
      examinationData: this.belongsTo(Examination, "examinationUuid"),
      sessionsGroupUuid: this.string(""),
      sessionsGroupData: this.belongsTo(SessionsGroup, "sessionsGroupUuid"),
    };
  }

  static querySessionsWithCertificationData() {
    const SessionRepo = useRepo(Session);

    return SessionRepo.with("examinationData", (query) =>
      query.with("stepData", (query) =>
        query.with("cycleData", (query) =>
          query.with("domainVersionData", (query) => query.with("domainData")),
        ),
      ),
    );
  }
}
